import { render, staticRenderFns } from "./EmbellishmentEdit.vue?vue&type=template&id=5a512359&"
import script from "./EmbellishmentEdit.vue?vue&type=script&lang=js&"
export * from "./EmbellishmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmbellishmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports